// loader-interceptor.service.ts
import { Injectable } from '@angular/core';
import {
  HttpResponse,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from '../services/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];
  private excludedRequests: string[] = ['/api/search/suggest'];

  constructor(private loaderService: LoaderService) { }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1);
    }
    // this.requests.pop();
    // console.log("No of requests--->" + this.requests.length);
    // console.log("Requests: " + JSON.stringify(this.requests));
    this.loaderService.isLoading.next(this.requests.length > 0);
  }

  isExcluded(reqUrl: string): boolean {
    let excluded = false;
    this.excludedRequests.forEach(e => {
      if (reqUrl.includes(e)) {
         excluded = true;
         return;
      }
    });

    return excluded;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    // console.log("Req: " + req.url);
    // console.log("No of requests--->" + this.requests.length);

    if (!this.isExcluded(req.url)) {
      this.requests.push(req);
      this.loaderService.isLoading.next(true);
    }

    return new Observable((observer: any) => {
      const subscription = next.handle(req)
        .subscribe({
          next: event => {
            if (event instanceof HttpResponse) {
              this.removeRequest(req);
              observer.next(event);
            }
          },
          error: err => {
            alert('error' + err);
            this.removeRequest(req);
            observer.error(err);
          },
          complete: () => {
            this.removeRequest(req);
            observer.complete();
          }
        });
      // remove request from queue when cancelled
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
